// eslint-disable-next-line max-classes-per-file
import { Uuid } from '@ftr/contracts/type/shared'

export const PEOPLE_PEOPLE_ACTION_SCOPE = '[People Profiles]'
export class InitialisePeopleProfilesCommand {
  static readonly type = `${PEOPLE_PEOPLE_ACTION_SCOPE} Initialise People Profile`
  constructor(readonly courtSystemId: Uuid) {}
}

export class FetchPeopleProfileCommand {
  static readonly type = `${PEOPLE_PEOPLE_ACTION_SCOPE} Fetch People Profile`
  constructor(readonly courtSystemId: Uuid) {}
}
